<div class="registry-wrapper">

  <!-- ── Page Header ──────────────────────────────────────────────────────── -->
  <div class="page-header">
    <div class="header-left">
      <span class="section-label">APPLICANT MANAGEMENT</span>
      <h1 class="page-title">Legacy Registry</h1>
      <p class="page-subtitle">
        {{ isLoading ? 'Loading...' : (totalCount + ' applicants from the legacy database') }}
      </p>
    </div>
    <div class="header-right">
      <select class="year-select" [(ngModel)]="selectedYear" (change)="onYearChange()">
        <option *ngFor="let yr of availableYears" [value]="yr">{{ yr }}</option>
      </select>
      <button class="btn-refresh" (click)="loadApplicants()" [disabled]="isLoading">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          [class.spinning]="isLoading">
          <polyline points="23 4 23 10 17 10"></polyline>
          <path d="M1 20v-6h6"></path>
          <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
        </svg>
        Refresh
      </button>
    </div>
  </div>

  <!-- ── Stat Cards ────────────────────────────────────────────────────────── -->
  <div class="stats-grid" [class.skeleton-mode]="isLoading">
    <div class="stat-card stat-total">
      <div class="stat-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      </div>
      <div class="stat-data">
        <span class="stat-value">{{ isLoading ? '–' : totalCount }}</span>
        <span class="stat-label">Total Applicants</span>
      </div>
    </div>
    <div class="stat-card stat-pending">
      <div class="stat-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <div class="stat-data">
        <span class="stat-value">{{ isLoading ? '–' : pendingCount }}</span>
        <span class="stat-label">Pending Review</span>
      </div>
    </div>
    <div class="stat-card stat-review">
      <div class="stat-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </div>
      <div class="stat-data">
        <span class="stat-value">{{ isLoading ? '–' : underReviewCount }}</span>
        <span class="stat-label">Under Review</span>
      </div>
    </div>
    <div class="stat-card stat-accepted">
      <div class="stat-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>
      <div class="stat-data">
        <span class="stat-value">{{ isLoading ? '–' : acceptedCount }}</span>
        <span class="stat-label">Accepted</span>
      </div>
    </div>
    <div class="stat-card stat-rejected">
      <div class="stat-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <div class="stat-data">
        <span class="stat-value">{{ isLoading ? '–' : rejectedCount }}</span>
        <span class="stat-label">Rejected</span>
      </div>
    </div>
    <div class="stat-card stat-waitlisted">
      <div class="stat-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="8" y1="6" x2="21" y2="6"></line>
          <line x1="8" y1="12" x2="21" y2="12"></line>
          <line x1="8" y1="18" x2="21" y2="18"></line>
          <line x1="3" y1="6" x2="3.01" y2="6"></line>
          <line x1="3" y1="12" x2="3.01" y2="12"></line>
          <line x1="3" y1="18" x2="3.01" y2="18"></line>
        </svg>
      </div>
      <div class="stat-data">
        <span class="stat-value">{{ isLoading ? '–' : waitlistedCount }}</span>
        <span class="stat-label">Waitlisted</span>
      </div>
    </div>
  </div>

  <!-- ── Table Controls ────────────────────────────────────────────────────── -->
  <div class="table-controls">
    <div class="search-box">
      <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input type="text" placeholder="Search by name, programme or ID…"
        [(ngModel)]="searchQuery" (input)="onSearch()" class="search-input" />
    </div>
    <div class="filter-tabs">
      <button *ngFor="let f of filters" class="filter-tab"
        [class.active]="activeFilter === f" (click)="setFilter(f)">
        {{ f }}
      </button>
    </div>
  </div>

  <!-- ── Error State ───────────────────────────────────────────────────────── -->
  <div *ngIf="errorMessage" class="error-banner">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
    {{ errorMessage }}
    <button (click)="loadApplicants()" class="retry-btn">Retry</button>
  </div>

  <!-- ── Loading Skeleton ──────────────────────────────────────────────────── -->
  <div *ngIf="isLoading" class="table-container">
    <table class="applicants-table">
      <thead>
        <tr>
          <th>#</th><th>APPLICANT</th><th>PROGRAMME TYPE</th>
          <th>TYPE</th><th>ACADEMIC YEAR</th><th>STATUS</th>
          <th>APPLIED ON</th><th>ACTIONS</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let i of [1,2,3,4,5]" class="skeleton-row">
          <td><div class="skel skel-sm"></div></td>
          <td>
            <div class="applicant-cell">
              <div class="skel skel-avatar"></div>
              <div class="skel-lines">
                <div class="skel skel-line-lg"></div>
                <div class="skel skel-line-sm"></div>
              </div>
            </div>
          </td>
          <td><div class="skel skel-line-md"></div></td>
          <td><div class="skel skel-line-sm"></div></td>
          <td><div class="skel skel-line-sm"></div></td>
          <td><div class="skel skel-badge"></div></td>
          <td><div class="skel skel-line-sm"></div></td>
          <td>
            <div class="action-btns">
              <div class="skel skel-btn"></div>
              <div class="skel skel-btn"></div>
              <div class="skel skel-btn"></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ── Data Table ────────────────────────────────────────────────────────── -->
  <div *ngIf="!isLoading && !errorMessage" class="table-container">
    <table class="applicants-table">
      <thead>
        <tr>
          <th>#</th>
          <th>APPLICANT</th>
          <th>PROGRAMME TYPE</th>
          <th>TYPE</th>
          <th>ACADEMIC YEAR</th>
          <th>STATUS</th>
          <th>APPLIED ON</th>
          <th>ACTIONS</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="filteredApplicants.length === 0">
          <td colspan="8" class="empty-state">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <p>No applicants found for the selected filters.</p>
          </td>
        </tr>

        <tr *ngFor="let applicant of paginatedApplicants; let i = index"
            class="data-row"
            [class.updating]="updatingId === applicant.personId">

          <td class="row-num">{{ (currentPage - 1) * pageSize + i + 1 }}</td>

          <td>
            <div class="applicant-cell">
              <div class="avatar" [style.background]="getAvatarColor(applicant.applicantName)">
                {{ getInitials(applicant.applicantName) }}
              </div>
              <div class="applicant-info">
                <span class="applicant-name">{{ applicant.applicantName || '—' }}</span>
                <span class="applicant-id">ID: {{ applicant.personId }}</span>
              </div>
            </div>
          </td>

          <td class="programme-cell">{{ applicant.programmeType || '—' }}</td>

          <td>
            <span class="type-badge"
              [class.type-regular]="applicant.applicantType === 'REGULAR'"
              [class.type-mature]="applicant.applicantType === 'MATURE'">
              {{ applicant.applicantType || '—' }}
            </span>
          </td>

          <td class="center-cell">{{ applicant.academicYear || '—' }}</td>

          <td>
            <span class="status-badge"
              [class.status-pending]="applicant.status === 'PENDING'"
              [class.status-accepted]="applicant.status === 'ACCEPTED'"
              [class.status-rejected]="applicant.status === 'REJECTED'"
              [class.status-waitlisted]="applicant.status === 'WAITLISTED'"
              [class.status-review]="applicant.status === 'UNDER_REVIEW' || applicant.status === 'UNDER REVIEW'">
              {{ applicant.status || '—' }}
            </span>
          </td>

          <td class="date-cell">{{ formatDate(applicant.applicationReceivedDate) }}</td>

          <td>
            <div class="action-btns">
              <button class="btn-action btn-review"
                [disabled]="updatingId === applicant.personId"
                (click)="requestStatusUpdate(applicant, 'UNDER_REVIEW')">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                Review
              </button>
              <button class="btn-action btn-accept"
                [disabled]="updatingId === applicant.personId || applicant.status === 'ACCEPTED'"
                (click)="requestStatusUpdate(applicant, 'ACCEPTED')">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Accept
              </button>
              <button class="btn-action btn-reject"
                [disabled]="updatingId === applicant.personId || applicant.status === 'REJECTED'"
                (click)="requestStatusUpdate(applicant, 'REJECTED')">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
                Reject
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- ── Table Footer / Pagination ──────────────────────────────────────── -->
    <div class="table-footer">
      <span>
        Showing <strong>{{ getPageStart() }}–{{ getPageEnd() }}</strong> of
        <strong>{{ filteredApplicants.length }}</strong> applicants
      </span>
      <div class="pagination">
        <button class="page-btn nav-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <button *ngFor="let p of getPageNumbers()" class="page-btn"
          [class.active]="p === currentPage" (click)="goToPage(p)">
          {{ p }}
        </button>
        <button class="page-btn nav-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <!-- ── Confirmation Modal ────────────────────────────────────────────────── -->
  <div class="modal-overlay" *ngIf="showConfirmModal" (click)="cancelConfirm()">
    <div class="modal-card" (click)="$event.stopPropagation()">

      <div class="modal-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>

      <h2 class="modal-title">Confirm Admission</h2>
      <p class="modal-subtitle">
        You are about to accept <strong>{{ pendingApplicant?.applicantName }}</strong>
        for the <strong>{{ pendingApplicant?.programmeType }}</strong> programme.
      </p>

      <div class="modal-letter-option">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
        </svg>
        Would you like to generate and download the provisional admission letter?
      </div>

      <div class="modal-actions">
        <button class="modal-btn modal-btn-cancel" (click)="cancelConfirm()">
          Cancel
        </button>
        <button class="modal-btn modal-btn-secondary" (click)="confirmWithoutLetter()">
          Accept Only
        </button>
        <button class="modal-btn modal-btn-primary" (click)="confirmWithLetter()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
          Accept & Download Letter
        </button>
      </div>
    </div>
  </div>

  <!-- ── Toast Notification ────────────────────────────────────────────────── -->
  <div class="toast" [class.toast-show]="showToast"
    [class.toast-success]="toastType === 'success'"
    [class.toast-error]="toastType === 'error'">
    <svg *ngIf="toastType === 'success'" width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
    <svg *ngIf="toastType === 'error'" width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
    {{ toastMessage }}
  </div>

</div>